import type { DocumentPageTheme } from '@/lib/api/client'

export const twoImageTheme = {
  is_default: true,
  id: 'df425c50-62d3-41f4-bfb0-4a82351aad9b',
  name: 'Two Image Template',
  template_attributes: [
    {
      id: '2b5a9a41-67d4-4790-b42a-0304ab90cdee',
      creator: 0,
      data_type: 'table',
      template_values: {
        rows: [],
        type: 'parts-table',
        columns: [],
        isManual: true,
        position: {
          x: 4.67686578035986,
          y: -3.00010531556373,
        },
      },
    },
    {
      id: '57abcd9d-02a4-4d07-a40f-ba79cd3408dd',
      creator: 0,
      data_type: 'table',
      template_values: {
        rows: [],
        type: 'tools-table',
        columns: [],
        isManual: true,
        position: {
          x: 540.001591377683,
          y: -1.99850319931601,
        },
        columnsSize: {
          toolName: 200,
        },
      },
    },
    {
      id: '837c8d01-9218-4b87-bdb0-28f2b80e6d79',
      creator: 0,
      data_type: 'view',
      template_values: {
        type: 'view',
        viewId: null,
        position: {
          x: 19.516728877034,
          y: 132.088765788972,
        },
        imagePosition: 'absolute',
      },
    },
    {
      id: '33dd989a-1be4-4baa-ba8b-d90dfe4f1297',
      creator: 0,
      data_type: 'note',
      template_values: {
        type: 'note',
        content: '\u003Cp\u003E\u003C/p\u003E',
        position: {
          x: 408.63768115942,
          y: 350.12646484375,
        },
        notesPosition: 'absolute',
      },
    },
    {
      id: '843f8cb1-c0c3-4c02-87f2-771d045eed77',
      creator: 0,
      data_type: 'view',
      template_values: {
        type: 'view',
        viewId: null,
        position: {
          x: 395.889907552589,
          y: 132.095063909443,
        },
        imagePosition: 'absolute',
      },
    },
    {
      id: '67f6be65-a56b-46b1-a577-b1adada9d660',
      creator: 0,
      data_type: 'note',
      template_values: {
        type: 'note',
        content: '\u003Cp\u003E\u003C/p\u003E',
        position: {
          x: 32.2608695652174,
          y: 350.12646484375,
        },
        notesPosition: 'absolute',
      },
    },
  ] as any,
  theme_type: 'operation',
} as DocumentPageTheme
